import { Box, Button, Container, Grid, Typography } from '@mui/material'
import { SigninImg, SigninLogo } from 'app/signin/styles'
import Carousel from 'components/carousel'
import useNavigation from 'hooks/useNavigation'
import { listImages } from 'utils/catalogs'

export default function CheckEmail() {
  const { onNavigate } = useNavigation()
  const handleRedirect = () => {
    onNavigate('/login')
  }
  return (
    <Container>
      <Grid
        container
        paddingX={8}
        spacing={5}
        padding={0}
        justifyContent="center"
      >
        <Grid item md={5} paddingY={5}>
          <SigninLogo src="/images/logo.png" alt="logo" />
          <Box paddingTop={5} paddingRight={5}>
            <Typography variant="h1" paddingX="8px" paddingBottom={8}>
              Verify your email!
            </Typography>
            <Typography variant="h5" paddingBottom={3}>
              Check your email service to verify your user account.
            </Typography>
            <Button
              sx={{
                marginTop: 8
              }}
              onClick={handleRedirect}
              variant="contained"
              type="submit"
              fullWidth
            >
              Login
            </Button>
          </Box>
        </Grid>
        <Grid
          item
          md={6}
          sx={{
            display: { xs: 'none', md: 'block' }
          }}
        >
          <Carousel loop autoPlay interval={5000}>
            {listImages.map(item => (
              <SigninImg key={item.id} src={item.img} alt="logo" />
            ))}
          </Carousel>
        </Grid>
      </Grid>
    </Container>
  )
}
